import React, { useState } from 'react'
import "./Join.css";
import { Link } from 'react-router-dom';

let user;

const sendUser = ()=>{
  user=document.getElementById("joinInput").value;
  document.getElementById("joinInput").value="";
}


const Join = () => {
  const [name, setName] = useState("");
  
  return (
    <div className='JoinPage'>
      <div className="JoinContainer">
        <img src="https://cdn-icons-png.flaticon.com/512/9355/9355499.png" alt="logo" />
        <h1>CHAT APP</h1>
        <input type="text" onChange={(e)=>setName(e.target.value)} placeholder='Enter Your Name' id="joinInput" />
        <Link onClick={(e)=> !name?e.preventDefault():null} to="/chat" ><button onClick={sendUser} className="joinbtn">Login</button></Link>
      </div>
    </div>
  )
}

export default Join
export {user}

